import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';

import { mapReferencePrice, RawReferencePrice } from './mapReferencePrice';
import { Product } from './Product';

export interface RawProduct {
	readonly product: RawGeneralProduct;
	readonly packageSizeForCalculation: number | null;
	readonly packageSizeForSingleUnit: number | null;
	readonly singleUnitPackageSize: boolean;
	readonly referencePrices: RawReferencePrice[];
	readonly referenceDataSource: boolean;
	readonly selectable: boolean;
	readonly selected: boolean;
	readonly amountOfSubstanceInUnit: number | null;
}

export const mapProduct = (product: RawProduct) =>
	new Product(
		mapGeneralProduct(product.product),
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		product.singleUnitPackageSize,
		product.referencePrices.map(mapReferencePrice),
		product.referenceDataSource,
		product.selectable,
		product.selected,
		product.amountOfSubstanceInUnit
	);
